// IBAN — jednotná normalizácia a kontrola.
//
// Konvencia: v DB držíme IBAN BEZ medzier a veľkými písmenami; medzery po
// štvorčísliach dopĺňa až zobrazenie (faktúra). Keď sa uloží s medzerami,
// formátovanie ich pridá druhýkrát a číslo účtu sa rozsype.

export const normalizeIban = (v: string): string =>
  (v || '').replace(/[\s-]/g, '').toUpperCase().slice(0, 34);

export const formatIban = (v: string): string => {
  const s = normalizeIban(v);
  return s ? s.replace(/(.{4})/g, '$1 ').trim() : '';
};

/**
 * Kontrolné číslice podľa ISO 13616 (mod-97). Chytí preklep v čísle účtu —
 * na faktúre by znamenal platbu na neexistujúci účet.
 * @returns true/false, alebo null keď je pole prázdne (nemá čo hodnotiť)
 */
export function isIbanValid(v: string): boolean | null {
  const s = normalizeIban(v);
  if (!s) return null;
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/.test(s)) return false;
  const rearranged = s.slice(4) + s.slice(0, 4);
  let rem = 0;
  for (const ch of rearranged) {
    // písmená → 10..35, po jednej číslici (mod-97 po častiach kvôli presnosti)
    const digits = /\d/.test(ch) ? ch : String(ch.charCodeAt(0) - 55);
    for (const d of digits) rem = (rem * 10 + Number(d)) % 97;
  }
  return rem === 1;
}

/** Nápoveda pod pole: naformátovaný IBAN + výsledok kontroly. */
export function ibanHint(v: string): string | undefined {
  const valid = isIbanValid(v);
  if (valid === null) return undefined;
  return valid ? `${formatIban(v)} — kontrolné číslice sedia`
               : `${formatIban(v)} — ⚠ neplatný IBAN (skontroluj číslo)`;
}
